export const EmptyOption = { label: '', value: '' };

export function strsToOptions(strs: string[]) {
  return strs.map((str) => ({
    label: str,
    value: str,
  }));
}
